import CButton from '../../../Assets/Components/CButton';
import CICon from '../../../Assets/Components/CIcon';
import React from 'react';
import { Tag } from 'antd';
import moment from 'moment';
import CModalRFF from '../../../Assets/Components/CModalRFF';

interface IProps {
  handleCancel: () => void;
  handleOnClickDetail: (data: any) => void;
  listExamSchedule: any;
  modalIsShow: boolean;
  selectedDate: any;
}

export default function ModalListExamScheduleComponent(props: IProps) {
  const {
    handleCancel,
    handleOnClickDetail,
    listExamSchedule,
    modalIsShow,
    selectedDate,
  } = props;

  const headerComponent = () => {
    return <h3 className="headerTitle capital">Detail Schedule</h3>;
  };

  const contentComponent = () => {
    return (
      <>
        <div className="selectedDateModal">
          {moment(selectedDate).format('dddd')},{' '}
          {moment(selectedDate).format('DD-MMM-YYYY')}
        </div>
        <div className="containerListExamSchedule">
          {listExamSchedule.map((data, index) => {
            const dataButton = [
              {
                type: 'link',
                id: `btnDetailSchedule${index}`,
                className: 'btnDetailSchedule',
                content: 'Detail',
                onClick: () => handleOnClickDetail(data),
              },
            ];

            return (
              <div
                key={`${data.code}${index}`}
                className="containerExamSchedule"
              >
                {data.examType === 0 ? (
                  <>
                    <Tag color={'#FB6915'} className="tagExam">
                      Examination
                    </Tag>
                    <CICon type="FieldTimeOutlined" className="iconFieldTime" />
                    {data.startTime} - {data.endTime}
                    <CICon type="DesktopOutlined" className="iconDesktop" />
                    <span className="colorGreen">Online</span>
                    <CICon type="EnvironmentOutlined" className="iconEnv" />
                    {data.city}
                  </>
                ) : (
                  <>
                    <Tag color={'#FB6915'} className="tagExam">
                      Examination
                    </Tag>
                    <CICon type="MobileOutlined" className="iconMobile" />
                    <span className="descMobile">Mobile Apps</span>
                  </>
                )}
                <CButton buttonData={dataButton} buttonFloat="right" />
              </div>
            );
          })}
        </div>
      </>
    );
  };

  return (
    <CModalRFF
      handleSubmit={() => {}}
      handleCancel={handleCancel}
      modalIsShow={modalIsShow}
      initialValues={[]}
      headerComponent={headerComponent()}
      contentComponent={contentComponent()}
      footerComponent={null}
    />
  );
}
